<template>
  <div :class="ns.b()">
    <div :class="ns.e('image')" :style="imageStyle">
      <img v-if="image" :src="image" ondragstart="return false" />
      <slot v-else name="image">
        <img-empty />
      </slot>
    </div>
    <div :class="ns.e('description')">
      <slot v-if="$slots.description" name="description" />
      <p v-else>{{ emptyDescription }}</p>
    </div>
    <div v-if="$slots.default" :class="ns.e('bottom')">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useLocale, useNamespace } from '@zoryn/hooks'
import { addUnit } from '@zoryn/utils'
import ImgEmpty from './img-empty.vue'

import type { CSSProperties } from 'vue'
import type { EmptyProps } from './empty'

defineOptions({
  name: 'ZEmpty',
})

const props = withDefaults(defineProps<EmptyProps>(), {
  image: '',
  description: '',
})

const { t } = useLocale()
const ns = useNamespace('empty')
const emptyDescription = computed(
  () => props.description || t('z.table.emptyText')
)
const imageStyle = computed<CSSProperties>(() => ({
  width: addUnit(props.imageSize),
}))
</script>
